import { render, staticRenderFns } from "./azureDisk.vue?vue&type=template&id=6e1174bb&"
import script from "./azureDisk.vue?vue&type=script&lang=js&"
export * from "./azureDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports